import request from '@/router/axios'

const BASE_URL = '/api/produce/device-alarm-records'
const WAGON_TIPPLER_URL = `${BASE_URL}/wagontippler`

export const getList = (data) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/select/page`,
    method: 'post',
    data
  })
}

export const getWagonAlarmRecordPage = getList

export const getOverview = (data) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/statistics/overview`,
    method: 'post',
    data
  })
}

export const getDetail = (id) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/detail`,
    method: 'get',
    params: { id }
  })
}

export const submitProcessStep = (data) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/process-step`,
    method: 'post',
    data
  })
}

export const batchConfirm = (ids, data) => {
  return request({
    url: `${BASE_URL}/batchAlarmHandling`,
    method: 'post',
    params: { ids },
    data
  })
}

export const oneClickConfirm = (data) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/oneClickAlarmHandling`,
    method: 'post',
    data
  })
}

export const exportClosedLoopPdf = (id) => {
  return request({
    url: `${WAGON_TIPPLER_URL}/closed-loop-report/pdf`,
    method: 'get',
    params: { id },
    responseType: 'blob'
  })
}
